import { MainAppResource } from './base';

export default function LicenceArea({ projectCode, licenceAreaCode }, data = {}) {
  let path = `api/v3/projects/${projectCode}/licence_areas`;

  if (licenceAreaCode) {
    path += `/${licenceAreaCode}`;
  }

  return MainAppResource(path, data, {
    fetch: { method: 'GET' },
    patch: { method: 'PATCH' },
    save: { method: 'POST' }
  });
}
